const getCcustoValoresFilterFields = (drops = {}, ccustoId) => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'ccusto_id',
    label: 'Centro de Custo',
    type: 'select',
    options: drops?.Ccusto,
    multiple: true,
    defaultValue: ccustoId ? [ccustoId] : [],
    show: false,
  },
  {
    name: 'vlrprep',
    label: 'Valor de Preparo',
    type: 'currency',
  },
  {
    name: 'vlrexec',
    label: 'Valor Hora de Execução',
    type: 'currency',
  },
  {
    name: 'inivalid',
    label: 'Data de Início',
    type: 'date',
  },
  {
    name: 'fimvalid',
    label: 'Data de Término',
    type: 'date',
  },
];

export default getCcustoValoresFilterFields;
